import { ReactComponent as EnIcon } from "./flags/en.svg";
import { ReactComponent as PlIcon } from "./flags/pl.svg";
import { ReactComponent as RuIcon } from "./flags/ru.svg";
import { ReactComponent as UaIcon } from "./flags/ua.svg";
import { ReactComponent as UkIcon } from "./flags/uk.svg";

export { EnIcon, PlIcon, RuIcon, UaIcon, UkIcon  }